import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.scss';
import Logo from '../../assets/images/logo/SKAI_INTEELIGENCE_logo_white.svg';
import GonganIcon from '../../assets/images/gonganIcon.jpg';

const AppFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="app-footer">
      <div className="content">
        <div className="info-wrap">
          <img src={Logo} alt="logo" />
          <div className="info-wrap">
            <h5>{t(`appFooter.companyName`)}</h5>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td>{t(`appFooter.CEO`)}</td>
                  <td>{t(`appFooter.Lee`)}</td>
                </tr>
                <tr>
                  <td>{t(`appFooter.brn`)}</td>
                  <td>294-88-03070</td>
                </tr>
                <tr>
                  <td>{t(`appFooter.address`)}</td>
                  <td>{t(`appFooter.addrValue`)}</td>
                </tr>
                <tr>
                  <td>{t(`appFooter.email`)}</td>
                  <td>contact@skaiintelligence.co.kr</td>
                </tr>
              </tbody>
            </table>
            <div className="link-wrap">
              <Link to="/privacy" target="blank">
                {t(`appFooter.privacy`)}
              </Link>
              <strong>FamilySite</strong>
              <Link to="https://www.skaiworldwide.com/" target="blank">
                {t(`appFooter.worldwide`)}
              </Link>
              <Link to="https://www.sesame-digital.com/" target="blank">
                {t(`appFooter.sesame`)}
              </Link>
              <Link to="http://directorscompany.co.kr/" target="blank">
                {t(`appFooter.directors`)}
              </Link>
              <Link to="http://creativeair.co.kr/" target="blank">
                {t(`appFooter.creative`)}
              </Link>
              <Link to="https://dweitzer.com/" target="blank">
                {t(`appFooter.dad`)}
              </Link>
            </div>
            <div className="sns-wrap">
              <Link
                to="https://www.instagram.com/skai_intelligence"
                target="blank"
              ></Link>
              <Link
                to="https://www.linkedin.com/company/skaiintelligence/posts/?feedView=all"
                target="blank"
              ></Link>
              <Link
                to="https://www.youtube.com/@skaiintelligence"
                target="blank"
              ></Link>
            </div>
          </div>
        </div>
        <div className="copy-wrap">
          <span>
            Copyright © 2025 SKAI Intelligence, Inc. All Rights Reserved.
          </span>
          <br />
          <span>沪ICP备2025115871号</span>
          <br />
          <span>
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=31010902100871"
              rel="noreferrer"
              target="_blank"
              style={{
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              <img src={GonganIcon} alt="" style={{ width: '12px', marginRight: '4px' }} />
              沪公网安备31010902100871号
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
